export default "__VITE_ASSET__DU64PIJY__"